// ContactList.tsx
import React, { useState, useMemo } from 'react';
import { DataGrid, GridColDef, GridRowClassNameParams } from '@mui/x-data-grid';
import { TextField, Box } from '@mui/material';
import { Contact } from '../../models';

interface ContactListProps {
  contacts: Contact[];
  onRowClick: (contact: Contact) => void;
}

const ContactList: React.FC<ContactListProps> = ({ contacts, onRowClick }) => {
  const [searchText, setSearchText] = useState('');

  // Filter contacts by name, email, or phone number.
  const filteredContacts = useMemo(() => {
    return contacts.filter((contact) =>
      contact.name.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.email.toLowerCase().includes(searchText.toLowerCase()) ||
      contact.phoneNumber.includes(searchText)
    );
  }, [contacts, searchText]);

  // Define columns and add Tailwind classes for the header.
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      headerClassName: 'bg-blue-500 text-white font-bold'
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      flex: 1,
      headerClassName: 'bg-blue-500 text-white font-bold'
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      headerClassName: 'bg-blue-500 text-white font-bold'
    },
    {
      field: 'active',
      headerName: 'Active',
      type: 'boolean',
      flex: 1,
      headerClassName: 'bg-blue-500 text-white font-bold'
    },
  ];

  // Use getRowClassName to assign Tailwind classes for row striping and hover effects.
  const getRowClassName = (params: GridRowClassNameParams) =>
    params.indexRelativeToCurrentPage % 2 === 0
      ? 'bg-gray-100 hover:bg-gray-200 cursor-pointer'
      : 'bg-white hover:bg-gray-200 cursor-pointer';

  return (
    <Box>
      <TextField
        label="Search"
        variant="outlined"
        fullWidth
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        margin="normal"
      />
      <div className="h-96 w-full">
        <DataGrid
          rows={filteredContacts}
          columns={columns}
          onRowClick={(params: any) => onRowClick(params.row)}
          getRowClassName={getRowClassName}
          hideFooterSelectedRowCount
        />
      </div>
    </Box>
  );
};

export default ContactList;
